import { ValidationResults, TestResults } from "../types";

export function arrayOf<Arr extends any[], Fn extends (arg: Arr[0]) => any>(
    arr: Arr,
    testCb: Fn
): (ReturnType<Fn> | void)[] {
    return arr.map(testCb);
}
